/* ==========================================================
   MT – Interactividad de las secciones propias (vanilla JS)
   ========================================================== */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Entradas al hacer scroll ---------- */
  function initReveal(root) {
    var els = (root || document).querySelectorAll('.mt-reveal:not(.mt-visible), .mt-reveal-img:not(.mt-visible)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('mt-visible');
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Parallax suave ---------- */
  function initParallax() {
    var els = document.querySelectorAll('[data-mt-parallax]');
    if (!els.length || reduce) return;
    var ticking = false;
    function update() {
      var vh = window.innerHeight;
      els.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        var intensidad = parseFloat(el.getAttribute('data-mt-parallax')) || 0;
        var progreso = (r.top + r.height / 2 - vh / 2) / vh;
        el.style.setProperty('--mt-parallax', (progreso * intensidad * -1).toFixed(1) + 'px');
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  /* ---------- Cifras que cuentan ---------- */
  function initCifras() {
    var els = document.querySelectorAll('[data-mt-contar]:not([data-mt-listo])');
    if (!els.length) return;
    function formatear(n, dec) {
      return n.toLocaleString(document.documentElement.lang || 'en', { minimumFractionDigits: dec, maximumFractionDigits: dec });
    }
    function animar(el) {
      el.setAttribute('data-mt-listo', '');
      var fin = parseFloat(el.getAttribute('data-mt-contar')) || 0;
      var dec = (String(el.getAttribute('data-mt-contar')).split('.')[1] || '').length;
      var dur = parseInt(el.getAttribute('data-mt-duracion'), 10) || 2000;
      if (reduce) { el.textContent = formatear(fin, dec); return; }
      var t0 = null;
      function paso(t) {
        if (!t0) t0 = t;
        var p = Math.min((t - t0) / dur, 1);
        var e = 1 - Math.pow(1 - p, 4);
        el.textContent = formatear(fin * e, dec);
        if (p < 1) window.requestAnimationFrame(paso);
      }
      window.requestAnimationFrame(paso);
    }
    if (!('IntersectionObserver' in window)) { els.forEach(animar); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { animar(e.target); io.unobserve(e.target); }
      });
    }, { threshold: 0.4 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Página de producto ---------- */
  function initProducto() {
    document.querySelectorAll('[data-mt-producto]:not([data-mt-listo])').forEach(function (raiz) {
      raiz.setAttribute('data-mt-listo', '');

      /* Galería */
      var principal = raiz.querySelector('[data-mt-principal]');
      raiz.querySelectorAll('[data-mt-mini]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (!principal) return;
          raiz.querySelectorAll('[data-mt-mini]').forEach(function (b) { b.classList.remove('is-activa'); });
          btn.classList.add('is-activa');
          principal.classList.add('is-cambiando');
          setTimeout(function () {
            principal.src = btn.getAttribute('data-src');
            principal.srcset = btn.getAttribute('data-srcset') || '';
            principal.alt = btn.getAttribute('data-alt') || '';
            principal.onload = function () { principal.classList.remove('is-cambiando'); };
            setTimeout(function () { principal.classList.remove('is-cambiando'); }, 400);
          }, 200);
        });
      });

      /* Cantidad */
      var qty = raiz.querySelector('[data-mt-qty]');
      raiz.querySelectorAll('[data-mt-qty-btn]').forEach(function (b) {
        b.addEventListener('click', function () {
          if (!qty) return;
          var v = (parseInt(qty.value, 10) || 1) + parseInt(b.getAttribute('data-mt-qty-btn'), 10);
          qty.value = Math.max(1, v);
        });
      });

      /* Variantes */
      var datos = raiz.querySelector('[data-mt-variantes]');
      var variantes = datos ? JSON.parse(datos.textContent) : [];
      var inputId = raiz.querySelector('input[name="id"]');
      var precio = raiz.querySelector('[data-mt-precio]');
      var tachado = raiz.querySelector('[data-mt-tachado]');
      var ahorro = raiz.querySelector('[data-mt-ahorro]');
      var botones = document.querySelectorAll('[data-mt-boton-' + raiz.getAttribute('data-mt-producto') + ']');
      var stock = raiz.querySelector('[data-mt-stock]');
      var formato = raiz.getAttribute('data-mt-moneda') || '{{amount_with_comma_separator}} €';
      var txtComprar = raiz.getAttribute('data-mt-txt-comprar');
      var txtAgotado = raiz.getAttribute('data-mt-txt-agotado');
      var txtStock = raiz.getAttribute('data-mt-txt-stock');
      var txtSinStock = raiz.getAttribute('data-mt-txt-sinstock');

      function dinero(cents) {
        var n = (cents / 100).toFixed(2);
        var partes = n.split('.');
        var miles = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        var coma = miles + ',' + partes[1];
        var punto = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + partes[1];
        return formato
          .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, coma)
          .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, miles)
          .replace(/\{\{\s*amount_no_decimals\s*\}\}/, partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, ','))
          .replace(/\{\{\s*amount\s*\}\}/, punto)
          .replace(/<[^>]*>/g, '');
      }

      function actualizar() {
        var sel = [];
        raiz.querySelectorAll('[data-mt-opcion]').forEach(function (fs) {
          var c = fs.querySelector('input:checked');
          sel.push(c ? c.value : null);
          var etiqueta = fs.querySelector('legend span');
          if (etiqueta && c) etiqueta.textContent = c.value;
        });
        var v = variantes.find(function (vr) {
          return vr.options.every(function (o, i) { return o === sel[i]; });
        });
        botones.forEach(function (b) {
          b.disabled = !v || !v.available;
          var t = b.querySelector('[data-mt-boton-txt]') || b;
          t.textContent = v && v.available ? txtComprar : txtAgotado;
        });
        if (!v) return;
        if (inputId) inputId.value = v.id;
        if (precio) precio.textContent = dinero(v.price);
        if (tachado) {
          var hay = v.compare_at_price && v.compare_at_price > v.price;
          tachado.textContent = hay ? dinero(v.compare_at_price) : '';
          tachado.hidden = !hay;
          if (ahorro) {
            ahorro.hidden = !hay;
            var pre = ahorro.getAttribute('data-prefijo');
            if (hay) ahorro.textContent = (pre ? pre + ' ' : '-') + Math.round((1 - v.price / v.compare_at_price) * 100) + '%';
          }
          var nota = raiz.querySelector('[data-mt-nota-tachado]');
          if (nota) nota.hidden = !hay;
        }
        if (stock) {
          stock.classList.toggle('is-agotado', !v.available);
          var st = stock.querySelector('span');
          if (st) st.textContent = v.available ? txtStock : txtSinStock;
        }
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
        if (v.featured_media && v.featured_media.id) {
          var mini = raiz.querySelector('[data-mt-mini][data-media-id="' + v.featured_media.id + '"]');
          if (mini) mini.click();
        }
      }
      raiz.querySelectorAll('[data-mt-opcion] input').forEach(function (i) {
        i.addEventListener('change', actualizar);
      });

      /* Añadir al carrito sin salir de la página (abre el carrito lateral de Dawn) */
      var form = raiz.querySelector('form[data-mt-form]');
      if (form) {
        form.addEventListener('submit', function (ev) {
          var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
          if (!cart || typeof cart.renderContents !== 'function' || !window.fetch) return;
          ev.preventDefault();
          var btn = form.querySelector('[type="submit"]');
          if (btn) btn.setAttribute('aria-busy', 'true');
          var fd = new FormData(form);
          if (qty) fd.set('quantity', qty.value);
          if (typeof cart.getSectionsToRender === 'function') {
            fd.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
            fd.append('sections_url', window.location.pathname);
            if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
          }
          var url = (window.routes && window.routes.cart_add_url) || '/cart/add';
          fetch(url, {
            method: 'POST',
            headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
            body: fd
          })
            .then(function (r) { return r.json(); })
            .then(function (res) {
              if (res.status) {
                var err = raiz.querySelector('[data-mt-error]');
                if (err) { err.textContent = res.description || res.message; err.hidden = false; }
                return;
              }
              cart.classList.remove('is-empty');
              cart.renderContents(res);
            })
            .catch(function () { form.submit(); })
            .finally(function () { if (btn) btn.removeAttribute('aria-busy'); });
        });
      }

      /* Barra de compra fija en móvil/escritorio al pasar el botón */
      var barra = document.querySelector('[data-mt-barra="' + raiz.getAttribute('data-mt-producto') + '"]');
      var ancla = raiz.querySelector('[data-mt-ancla]');
      if (barra && ancla && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          var e = entries[0];
          barra.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
        }).observe(ancla);
        var bb = barra.querySelector('button');
        if (bb) bb.addEventListener('click', function () {
          if (form) {
            if (form.requestSubmit) form.requestSubmit(); else form.submit();
          }
        });
      }
    });
  }

  /* "Descubre más": baja suavemente hasta la siguiente sección */
  document.addEventListener('click', function (e) {
    var enlace = e.target.closest && e.target.closest('[data-mt-bajar]');
    if (!enlace) return;
    var seccion = enlace.closest('.shopify-section');
    var siguiente = seccion && seccion.nextElementSibling;
    while (siguiente && siguiente.offsetHeight === 0) siguiente = siguiente.nextElementSibling;
    if (!siguiente) return;
    e.preventDefault();
    var y = siguiente.getBoundingClientRect().top + window.pageYOffset;
    window.scrollTo({ top: y, behavior: reduce ? 'auto' : 'smooth' });
  });

  function initTodo(root) {
    initReveal(root);
    initCifras();
    initProducto();
  }

  document.addEventListener('DOMContentLoaded', function () {
    initTodo(document);
    initParallax();
  });

  /* Editor de Shopify: re-inicializa al añadir/editar secciones */
  document.addEventListener('shopify:section:load', function (e) { initTodo(e.target); });
})();
